exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info-note-icon[data-v-feb837ac]{cursor:pointer}.info-note[data-v-feb837ac]{background-color:#f7f7f9;border-color:#ccc;color:#000}.alert[class*=alert-styled-][data-v-feb837ac]:after{color:#000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-feb837ac","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/notes/info-note.vue
// module id = 1804
// module chunks = 0